export default __webpack_public_path__ + "static/media/motorbike.248246de.svg";